import { useState } from "react";
import { inr, initials, fmtDate } from "@/lib/fmt";

export function LeadCard({ lead, onOpen, draggable, users, extra }) {
  const owner = users?.find((u) => u.email === lead.owner);
  return (
    <div draggable={draggable} onDragStart={(e) => e.dataTransfer.setData("text/lead", lead._id)}
      onClick={() => onOpen(lead._id)} data-testid={`lead-card-${lead._id}`}
      className="panel-2 p-2.5 cursor-pointer hover:border-[var(--border-strong)] transition-colors">
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0 pr-24">
          <div className="text-[13px] font-medium truncate">{lead.name}</div>
          <div className="text-[11px] text-neutral-500 truncate">{lead.email || lead.phone || "—"}</div>
        </div>
        {lead.owner && (
          <span title={owner?.name || lead.owner} className="w-5 h-5 shrink-0 rounded-full bg-[#1f1f23] text-[9px] flex items-center justify-center text-neutral-300">
            {initials(owner?.name || lead.owner)}
          </span>
        )}
      </div>
      <div className="flex items-center gap-2 mt-2 text-[10px] text-neutral-500">
        {lead.gmv ? <span className="text-neutral-300">{inr(lead.gmv)}</span> : null}
        {lead.event_date && <span>{fmtDate(lead.event_date)}</span>}
        <span className="ml-auto truncate max-w-[110px]">{lead.utm?.utm_source || lead.source}</span>
      </div>
      {extra}
    </div>
  );
}

function Column({ stage, leads, onOpen, onDrop, users }) {
  const [over, setOver] = useState(false);
  return (
    <div className={`kanban-col w-64 shrink-0 rounded-md p-1.5 transition-colors ${over ? "drop-over" : ""}`}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
      onDrop={(e) => { setOver(false); const id = e.dataTransfer.getData("text/lead"); if (id) onDrop(id, stage); }}
      data-testid={`kanban-col-${stage}`}>
      <div className="flex items-center justify-between px-1.5 py-1 mb-1.5">
        <span className="text-[11px] uppercase tracking-wider text-neutral-400">{stage}</span>
        <span className="text-[11px] font-mono text-neutral-600">{leads.length}</span>
      </div>
      <div className="space-y-1.5 min-h-[80px]">
        {leads.map((l) => <LeadCard key={l._id} lead={l} onOpen={onOpen} draggable users={users} />)}
      </div>
    </div>
  );
}

export default function Kanban({ stages, leads, onOpen, onMove, users }) {
  const extra = [...new Set(leads.map((l) => l.stage).filter((s) => s && !stages.includes(s)))];
  const cols = [...stages, ...extra];
  return (
    <div className="flex gap-2 overflow-x-auto pb-4" data-testid="kanban-board">
      {cols.map((s) => (
        <Column key={s} stage={s} leads={leads.filter((l) => (l.stage || stages[0]) === s)} onOpen={onOpen} users={users}
          onDrop={(id, stage) => onMove(id, stage)} />
      ))}
    </div>
  );
}
